<template>
	<Carousel v-model:page="activeItemIndex" :value="itemList" :num-visible="1" :num-scroll="1" :autoplay-interval="4000" circular :showNavigators="false" :show-indicators="false">
		<template #item="{ data }">
			<div class="page-header-image">
				<img class="page-header-image-item desktop" v-if="data.ImageUrl" :src="data.ImageUrl" :alt="data.ImageAltText" />
        		<img class="page-header-image-item mobile" v-if="data.MobileImageUrl" :src="data.MobileImageUrl" :alt="data.ImageAltText" />
			</div>
		</template>
	</Carousel>
</template>
<script lang="ts" setup>
	import Carousel from 'primevue/carousel';
	import { onMounted, ref } from 'vue';

  interface HeaderImageModel {
		ImageUrl?: string;
		MobileImageUrl?: string;
		ImageAltText?: string;
	}

	const props = defineProps({
		items: {
			type: String,
			required: true,
		},
	});

	const activeItemIndex = ref<number>(0);
  const itemList = ref<HeaderImageModel[]>([]);

	onMounted(() => {
		itemList.value = JSON.parse(props.items);
	});
</script>
